var map = {
	"./match3/above.webp": "7e9f",
	"./match3/accordion.webp": "6c41",
	"./match3/afternoon.webp": "4ab5",
	"./match3/although.webp": "1712",
	"./match3/aluminum.webp": "d015",
	"./match3/amethyst.webp": "ae59",
	"./match3/and.webp": "e17a",
	"./match3/angry.webp": "9d13",
	"./match3/ant.webp": "2943",
	"./match3/apple.webp": "007e",
	"./match3/apple_tree.webp": "9c92",
	"./match3/arm.webp": "9681",
	"./match3/artist.webp": "efb9",
	"./match3/asteroid.webp": "ebaa",
	"./match3/attic.webp": "f294",
	"./match3/aunt.webp": "145b",
	"./match3/autumn.webp": "85bd",
	"./match3/axe.webp": "908d",
	"./match3/backpack.webp": "3583",
	"./match3/backward.webp": "3e7a",
	"./match3/bad.webp": "6863",
	"./match3/bag.webp": "6793",
	"./match3/balcony.webp": "e66f",
	"./match3/ball.webp": "b5b1",
	"./match3/bamboo.webp": "ba93",
	"./match3/banana.webp": "4d69",
	"./match3/bank.webp": "beba",
	"./match3/barley.webp": "a2b0",
	"./match3/barrel.webp": "76f2",
	"./match3/baseball.webp": "503d",
	"./match3/basement.webp": "c874",
	"./match3/basket.webp": "1494",
	"./match3/basketball.webp": "d00d",
	"./match3/bathroom.webp": "7e6b",
	"./match3/beach.webp": "cc6a",
	"./match3/bear.webp": "aff2",
	"./match3/beautiful.webp": "bcb2",
	"./match3/because.webp": "9ced",
	"./match3/bed.webp": "8a08",
	"./match3/bedroom.webp": "8a62",
	"./match3/bee.webp": "2a93",
	"./match3/beetle.webp": "77d8",
	"./match3/behind.webp": "0a29",
	"./match3/below.webp": "982d",
	"./match3/beside.webp": "7ac8",
	"./match3/between.webp": "b8f9",
	"./match3/bicycle.webp": "02e7",
	"./match3/big.webp": "8381",
	"./match3/birch.webp": "7bc0",
	"./match3/black.webp": "7cc1",
	"./match3/blocks.webp": "2712",
	"./match3/blue.webp": "e66d",
	"./match3/boat.webp": "d43f",
	"./match3/book.webp": "d4fd",
	"./match3/bored.webp": "d8a7",
	"./match3/bottle.webp": "4ef0",
	"./match3/bowl.webp": "3492",
	"./match3/box.webp": "6d15",
	"./match3/bread.webp": "2b22",
	"./match3/broccoli.webp": "5619",
	"./match3/bronze.webp": "12b5",
	"./match3/brother.webp": "4e45",
	"./match3/brown.webp": "44aa",
	"./match3/brownie.webp": "d196",
	"./match3/brush.webp": "b397",
	"./match3/bucket.webp": "576b",
	"./match3/buckwheat.webp": "5a66",
	"./match3/burger.webp": "4c46",
	"./match3/bus.webp": "77e6",
	"./match3/but.webp": "5901",
	"./match3/butterfly.webp": "d645",
	"./match3/cake.webp": "df95",
	"./match3/cake_dessert.webp": "67e5",
	"./match3/camera.webp": "5b2f",
	"./match3/camping.webp": "a370",
	"./match3/can.webp": "71d9",
	"./match3/candy.webp": "2e03",
	"./match3/canyon.webp": "af32",
	"./match3/car.webp": "1126",
	"./match3/car_toy.webp": "dff9",
	"./match3/carnation.webp": "f104",
	"./match3/carrot.webp": "a33d",
	"./match3/cat.webp": "b3a9",
	"./match3/cave.webp": "3351",
	"./match3/cedar.webp": "7d57",
	"./match3/cello.webp": "3522",
	"./match3/chair.webp": "85a0",
	"./match3/cheese.webp": "d7a7",
	"./match3/chef.webp": "772b",
	"./match3/cherry.webp": "dfda",
	"./match3/cherry_tree.webp": "2cb6",
	"./match3/chicken.webp": "14fc",
	"./match3/chocolate.webp": "17b5",
	"./match3/circle.webp": "b84c",
	"./match3/clean.webp": "edaf",
	"./match3/clean_verb.webp": "ae80",
	"./match3/cliff.webp": "1eae",
	"./match3/clock.webp": "197c",
	"./match3/cloud.webp": "67ac",
	"./match3/cocoa.webp": "5709",
	"./match3/coffee.webp": "302f",
	"./match3/cold.webp": "543b",
	"./match3/computer.webp": "8aee",
	"./match3/confused.webp": "5584",
	"./match3/cook.webp": "73d0",
	"./match3/cookie.webp": "85b0",
	"./match3/cooking_hobby.webp": "d417",
	"./match3/cool.webp": "20cc",
	"./match3/copper.webp": "29df",
	"./match3/corn.webp": "0ab0",
	"./match3/corn_grain.webp": "c7ce",
	"./match3/cotton.webp": "8403",
	"./match3/cow.webp": "d134",
	"./match3/crab.webp": "97f1",
	"./match3/crayon.webp": "8bdd",
	"./match3/crow.webp": "6f18",
	"./match3/crystal.webp": "2e88",
	"./match3/cucumber.webp": "d1b3",
	"./match3/cup.webp": "142f",
	"./match3/cupcake.webp": "828f",
	"./match3/cycling.webp": "bab8",
	"./match3/daisy.webp": "cabd",
	"./match3/dancing.webp": "aa4e",
	"./match3/daughter.webp": "fe37",
	"./match3/denim.webp": "72ca",
	"./match3/desert.webp": "58fb",
	"./match3/diamond.webp": "1681",
	"./match3/diamond_gem.webp": "0e6c",
	"./match3/dining_room.webp": "370b",
	"./match3/dirty.webp": "c36b",
	"./match3/doctor.webp": "d008",
	"./match3/dog.webp": "84a7",
	"./match3/doll.webp": "315f",
	"./match3/dolphin.webp": "1d5b",
	"./match3/donut.webp": "ba4a",
	"./match3/door.webp": "9866",
	"./match3/down.webp": "50be",
	"./match3/dragonfly.webp": "a59b",
	"./match3/drawing.webp": "967e",
	"./match3/dress.webp": "548a",
	"./match3/drill.webp": "2029",
	"./match3/drink.webp": "e21b",
	"./match3/drum.webp": "4bf3",
	"./match3/duck.webp": "80a4",
	"./match3/eagle.webp": "873c",
	"./match3/ear.webp": "469b",
	"./match3/earth.webp": "2f37",
	"./match3/east.webp": "7aab",
	"./match3/eat.webp": "e5b8",
	"./match3/egg.webp": "a3a1",
	"./match3/eight.webp": "7972",
	"./match3/elephant.webp": "b3e0",
	"./match3/emerald.webp": "6473",
	"./match3/eraser.webp": "5ac5",
	"./match3/evening.webp": "8ed4",
	"./match3/excited.webp": "4c75",
	"./match3/eye.webp": "d3f6",
	"./match3/farmer.webp": "a418",
	"./match3/father.webp": "97ac",
	"./match3/firefighter.webp": "77f2",
	"./match3/firefly.webp": "ebcc",
	"./match3/fish.webp": "7748",
	"./match3/fishing.webp": "aa94",
	"./match3/five.webp": "0fb9",
	"./match3/flamingo.webp": "3ce0",
	"./match3/flower.webp": "1838",
	"./match3/flute.webp": "fe7a",
	"./match3/foot.webp": "86ef",
	"./match3/forest.webp": "fd91",
	"./match3/fork.webp": "24f9",
	"./match3/forward.webp": "dfc9",
	"./match3/four.webp": "f791",
	"./match3/fridge.webp": "d3a5",
	"./match3/garage.webp": "0547",
	"./match3/garden.webp": "c9c2",
	"./match3/gardening.webp": "f6be",
	"./match3/garlic.webp": "39a4",
	"./match3/giraffe.webp": "3ceb",
	"./match3/gloves.webp": "2ec6",
	"./match3/glue.webp": "c667",
	"./match3/gold.webp": "660c",
	"./match3/good.webp": "0d9e",
	"./match3/grandfather.webp": "fe6b",
	"./match3/grandmother.webp": "78f6",
	"./match3/grape.webp": "35c2",
	"./match3/grass.webp": "b06c",
	"./match3/grasshopper.webp": "cbbe",
	"./match3/green.webp": "2872",
	"./match3/guitar.webp": "49ea",
	"./match3/hair.webp": "1998",
	"./match3/hammer.webp": "18bb",
	"./match3/hamster.webp": "17c7",
	"./match3/hand.webp": "3364",
	"./match3/happy.webp": "d73f",
	"./match3/harp.webp": "8c57",
	"./match3/hat.webp": "a40b",
	"./match3/head.webp": "08fa",
	"./match3/headphones.webp": "089e",
	"./match3/heart.webp": "7340",
	"./match3/helicopter.webp": "4756",
	"./match3/hexagon.webp": "d06b",
	"./match3/hiking.webp": "14e2",
	"./match3/hill.webp": "445b",
	"./match3/horse.webp": "3300",
	"./match3/hospital.webp": "a620",
	"./match3/hot.webp": "b883",
	"./match3/hotel.webp": "a61c",
	"./match3/house.webp": "5bda",
	"./match3/huge.webp": "84e2",
	"./match3/icecream.webp": "2894",
	"./match3/icecream_dessert.webp": "0c07",
	"./match3/if.webp": "8583",
	"./match3/in.webp": "7627",
	"./match3/in_front.webp": "2bcd",
	"./match3/iron.webp": "5633",
	"./match3/island.webp": "fa7c",
	"./match3/jacket.webp": "2de3",
	"./match3/jade.webp": "f1044",
	"./match3/jar.webp": "1794",
	"./match3/jasmine.webp": "5e98",
	"./match3/jelly.webp": "94ef",
	"./match3/jellyfish.webp": "8bb0",
	"./match3/juice.webp": "9105",
	"./match3/jump.webp": "b343",
	"./match3/jupiter.webp": "7984",
	"./match3/kangaroo.webp": "76e7",
	"./match3/keyboard.webp": "18ae",
	"./match3/kitchen_room.webp": "2e58",
	"./match3/kite.webp": "2fc0",
	"./match3/knife.webp": "deef",
	"./match3/knitting.webp": "bba7",
	"./match3/ladder.webp": "c9fd",
	"./match3/ladybug.webp": "834c",
	"./match3/lake.webp": "0998",
	"./match3/lamp.webp": "89e6",
	"./match3/large.webp": "f7e9",
	"./match3/leather.webp": "b7e8",
	"./match3/left.webp": "3cde",
	"./match3/leg.webp": "d960",
	"./match3/lemon.webp": "a9ad",
	"./match3/lemonade.webp": "f2a1",
	"./match3/library.webp": "7ced",
	"./match3/lightning.webp": "78c2",
	"./match3/lily.webp": "a2e6",
	"./match3/linen.webp": "090f",
	"./match3/lion.webp": "9e5e",
	"./match3/living_room.webp": "3779",
	"./match3/long.webp": "3f7d",
	"./match3/lotus.webp": "5d70",
	"./match3/mall.webp": "20a9",
	"./match3/maple.webp": "f264",
	"./match3/mars.webp": "88c1",
	"./match3/mercury.webp": "5d53",
	"./match3/mild.webp": "73b7",
	"./match3/milk.webp": "cdd1",
	"./match3/millet.webp": "a008",
	"./match3/mirror.webp": "9333",
	"./match3/monkey.webp": "d40e",
	"./match3/month.webp": "ca1e",
	"./match3/moon.webp": "dddd",
	"./match3/morning.webp": "43c4",
	"./match3/mosquito.webp": "c9ee",
	"./match3/mother.webp": "8164",
	"./match3/motorcycle.webp": "0538",
	"./match3/mountain.webp": "9e98",
	"./match3/mountain_land.webp": "a7f9",
	"./match3/mouse.webp": "b86e",
	"./match3/mouth.webp": "cf75",
	"./match3/museum.webp": "e75e",
	"./match3/mushroom.webp": "e9dc",
	"./match3/narrow.webp": "4566",
	"./match3/near.webp": "b544",
	"./match3/neptune.webp": "9720",
	"./match3/new.webp": "b7e4",
	"./match3/night.webp": "f42c",
	"./match3/nine.webp": "97f2",
	"./match3/noodles.webp": "e5f8",
	"./match3/north.webp": "5cc4",
	"./match3/nose.webp": "697b",
	"./match3/notebook.webp": "cb1d",
	"./match3/nurse.webp": "9d94",
	"./match3/nylon.webp": "4039",
	"./match3/oak.webp": "8af9",
	"./match3/oats.webp": "a7bd",
	"./match3/ocean.webp": "9d5c",
	"./match3/octopus.webp": "b0a5",
	"./match3/old.webp": "e006",
	"./match3/on.webp": "f64f",
	"./match3/one.webp": "b865",
	"./match3/onion.webp": "61b7",
	"./match3/opal.webp": "987b",
	"./match3/or.webp": "6bed",
	"./match3/orange_color.webp": "2a63",
	"./match3/orange_fruit.webp": "4079",
	"./match3/orchid.webp": "e2ca",
	"./match3/oval.webp": "8d8d",
	"./match3/oven.webp": "89ba",
	"./match3/owl.webp": "cf69",
	"./match3/painting.webp": "eb17",
	"./match3/palm.webp": "1454",
	"./match3/pan.webp": "7939",
	"./match3/panda.webp": "9a14",
	"./match3/pants.webp": "8efd",
	"./match3/parrot.webp": "a3ee",
	"./match3/peach.webp": "1157",
	"./match3/peacock.webp": "83ab",
	"./match3/pear.webp": "8ac6",
	"./match3/pearl.webp": "3b2b",
	"./match3/pen.webp": "6790",
	"./match3/pencil.webp": "2d55",
	"./match3/penguin.webp": "ea27",
	"./match3/peninsula.webp": "f399",
	"./match3/pentagon.webp": "cfaa",
	"./match3/pepper.webp": "4392",
	"./match3/phone.webp": "b532",
	"./match3/photography.webp": "58c0",
	"./match3/piano.webp": "a8bd",
	"./match3/pie.webp": "2d9e",
	"./match3/pig.webp": "3188",
	"./match3/pigeon.webp": "67b7",
	"./match3/pilot.webp": "5dde",
	"./match3/pine.webp": "2d05",
	"./match3/pink.webp": "7930",
	"./match3/pizza.webp": "90a9",
	"./match3/plain.webp": "368a",
	"./match3/plane.webp": "76ae",
	"./match3/plate.webp": "4a8f",
	"./match3/plateau.webp": "2d6e",
	"./match3/platinum.webp": "8398",
	"./match3/play.webp": "1a72",
	"./match3/pliers.webp": "b25f",
	"./match3/pluto.webp": "94e8",
	"./match3/police.webp": "5a17",
	"./match3/polyester.webp": "d683",
	"./match3/pot.webp": "7419",
	"./match3/potato.webp": "ee0a",
	"./match3/proud.webp": "251c",
	"./match3/pudding.webp": "6632",
	"./match3/purple.webp": "e890",
	"./match3/puzzle.webp": "f72e",
	"./match3/quinoa.webp": "6c36",
	"./match3/rabbit.webp": "20c4",
	"./match3/radio.webp": "d90b",
	"./match3/rain.webp": "1fdd",
	"./match3/rainbow.webp": "4a9c",
	"./match3/rake.webp": "2d06",
	"./match3/read.webp": "d235",
	"./match3/rectangle.webp": "f468",
	"./match3/red.webp": "fd6e",
	"./match3/rest.webp": "98f1",
	"./match3/restaurant.webp": "7a58",
	"./match3/rice.webp": "fa3b",
	"./match3/rice_grain.webp": "b45f",
	"./match3/right.webp": "8c10",
	"./match3/river.webp": "5368",
	"./match3/robot.webp": "5474",
	"./match3/rose.webp": "46b5",
	"./match3/ruby.webp": "d395",
	"./match3/ruler.webp": "c18c",
	"./match3/run.webp": "7f6e",
	"./match3/running.webp": "a1d9",
	"./match3/rye.webp": "b981",
	"./match3/sad.webp": "5d42",
	"./match3/sandwich.webp": "aaa3",
	"./match3/sapphire.webp": "3250",
	"./match3/satin.webp": "d862",
	"./match3/saturn.webp": "9c02",
	"./match3/saw.webp": "d9f1",
	"./match3/saxophone.webp": "22dc",
	"./match3/scared.webp": "ec21",
	"./match3/scarf.webp": "6aab",
	"./match3/school_building.webp": "4d9b",
	"./match3/scientist.webp": "b4ba",
	"./match3/scissors.webp": "b93b",
	"./match3/screwdriver.webp": "7628",
	"./match3/seahorse.webp": "a400",
	"./match3/season.webp": "84a2",
	"./match3/seven.webp": "29d5",
	"./match3/shake.webp": "16a7",
	"./match3/shark.webp": "12ca",
	"./match3/sheep.webp": "cb94",
	"./match3/ship.webp": "7ee8",
	"./match3/shirt.webp": "56f4",
	"./match3/shoes.webp": "a39d",
	"./match3/short.webp": "d2d7",
	"./match3/shovel.webp": "af44",
	"./match3/silk.webp": "02b5",
	"./match3/silver.webp": "873a",
	"./match3/sister.webp": "0101",
	"./match3/sit.webp": "eb16",
	"./match3/six.webp": "89a3",
	"./match3/skating.webp": "bb18",
	"./match3/skiing.webp": "236a",
	"./match3/skirt.webp": "961b",
	"./match3/sleep.webp": "f0ae",
	"./match3/small.webp": "eb71",
	"./match3/smoothie.webp": "26fb",
	"./match3/snow.webp": "c0c4",
	"./match3/so.webp": "79ac",
	"./match3/soccer.webp": "ce05",
	"./match3/socks.webp": "c91d",
	"./match3/soda.webp": "2e96",
	"./match3/sofa.webp": "e5cb",
	"./match3/son.webp": "1c75",
	"./match3/sorghum.webp": "2d12",
	"./match3/south.webp": "5859",
	"./match3/sparrow.webp": "6398",
	"./match3/speaker.webp": "5b9a",
	"./match3/spider.webp": "4e94",
	"./match3/spoon.webp": "24b4",
	"./match3/spring.webp": "e7e0",
	"./match3/square.webp": "b77e",
	"./match3/stadium.webp": "6d6d",
	"./match3/stand.webp": "444c",
	"./match3/star.webp": "6eda",
	"./match3/star_shape.webp": "8858",
	"./match3/starfish.webp": "152d",
	"./match3/steel.webp": "35bf",
	"./match3/strawberry.webp": "967c",
	"./match3/strong.webp": "5125",
	"./match3/study.webp": "0106",
	"./match3/suitcase.webp": "2037",
	"./match3/summer.webp": "0c1e",
	"./match3/sun.webp": "eb4b",
	"./match3/sunflower.webp": "ad0d",
	"./match3/surprised.webp": "168f",
	"./match3/swan.webp": "bdc2",
	"./match3/swimming.webp": "6378",
	"./match3/table.webp": "e39d",
	"./match3/tablet.webp": "df94",
	"./match3/tall.webp": "2a49",
	"./match3/tea.webp": "3737",
	"./match3/teacher.webp": "51c9",
	"./match3/teddy.webp": "dac1",
	"./match3/ten.webp": "4320",
	"./match3/tennis.webp": "29cd",
	"./match3/theater.webp": "6088",
	"./match3/three.webp": "d8f5",
	"./match3/thunder.webp": "1c00",
	"./match3/tiger.webp": "c764",
	"./match3/tiny.webp": "7bfa",
	"./match3/tired.webp": "9d2f",
	"./match3/titanium.webp": "7bb0",
	"./match3/today.webp": "d78a",
	"./match3/tomato.webp": "87f1",
	"./match3/tomorrow.webp": "40c4",
	"./match3/topaz.webp": "10a9",
	"./match3/train.webp": "f6c3",
	"./match3/train_toy.webp": "6317",
	"./match3/tree.webp": "a747",
	"./match3/triangle.webp": "3d66",
	"./match3/truck.webp": "3a85",
	"./match3/trumpet.webp": "66e9",
	"./match3/trunk.webp": "fffd",
	"./match3/tulip.webp": "3d5f",
	"./match3/turtle.webp": "eb2d",
	"./match3/tv.webp": "e74e",
	"./match3/two.webp": "2dd9",
	"./match3/ugly.webp": "b2dc",
	"./match3/uncle.webp": "dc79",
	"./match3/under.webp": "ccc4",
	"./match3/unless.webp": "e3c7",
	"./match3/up.webp": "bfd7",
	"./match3/uranus.webp": "ab66",
	"./match3/valley.webp": "19ec",
	"./match3/velvet.webp": "c4e1",
	"./match3/venus.webp": "3a37",
	"./match3/violet.webp": "98c8",
	"./match3/violin.webp": "04eb",
	"./match3/volleyball.webp": "4e09",
	"./match3/wake.webp": "968b",
	"./match3/walk.webp": "a5f5",
	"./match3/warm.webp": "441d",
	"./match3/wash.webp": "78d9",
	"./match3/water.webp": "8282",
	"./match3/watermelon.webp": "7865",
	"./match3/weak.webp": "acd2",
	"./match3/week.webp": "895f",
	"./match3/west.webp": "ae68",
	"./match3/whale.webp": "5ea8",
	"./match3/wheat.webp": "cf5d",
	"./match3/when.webp": "6ab2",
	"./match3/while.webp": "3a12",
	"./match3/white.webp": "ca81",
	"./match3/wide.webp": "1cc1",
	"./match3/willow.webp": "2c73",
	"./match3/wind.webp": "ff17",
	"./match3/window.webp": "f4f2",
	"./match3/winter.webp": "39d9",
	"./match3/wolf.webp": "41b9",
	"./match3/wool.webp": "7d1d",
	"./match3/work.webp": "3307",
	"./match3/wrench.webp": "d45f",
	"./match3/write.webp": "d9cf",
	"./match3/year.webp": "9a60",
	"./match3/yellow.webp": "e46b",
	"./match3/yesterday.webp": "0615",
	"./match3/yoyo.webp": "f03d",
	"./match3/zebra.webp": "a2bf",
	"./match3/zinc.webp": "c07c",
	"./placeholder.webp": "e36c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";